import { Tooltip } from 'antd';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * PRD-471: says why a greyed out "Add to Cart" cannot be clicked in the supplier comparison. A
 * disabled antd button swallows its own mouse events, so the tooltip has to hang off a wrapper
 * around it; when nothing is blocked the button is handed straight back, so the columns that can
 * still be checked out keep exactly the markup they had.
 */
export const AddToCartBlockedTooltip = ({
  blocked,
  children,
}: {
  blocked: boolean;
  children: ReactElement;
}) => {
  const { t } = useTranslation();
  if (!blocked) {
    return children;
  }
  return (
    <Tooltip title={t('jobConfig.addToCartBlockedForIndustryAverage')}>
      <span style={{ display: 'inline-flex' }}>{children}</span>
    </Tooltip>
  );
};
